!function(e,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):e.dlv=n()}(this,function(){function e(e,n,t,o){for(o=0,n=n.split?n.split("."):n;e&&o<n.length;)e=e[n[o++]];return void 0===e?t:e}return e});


//////////////////
// WEBPACK FOOTER
// ../node_modules/dlv/dist/dlv.umd.js
// module id = 105
// module chunks = 0


// WEBPACK FOOTER //
// node_modules/dlv/dist/dlv.umd.js